<div class="ui-payment-status" [ngClass]="type">
    <ui-screen-loader></ui-screen-loader>
</div>